import {
  Container,
  Divider,
  Group,
  Modal,
  ScrollArea,
  Stack,
} from '@mantine/core'

import React from 'react'

import { themeCfg } from '../../theme/theme'

interface CustomProps extends React.ComponentPropsWithoutRef<typeof Modal> {
  size?: 'xl' | 'md'
  opened: boolean
  close: () => void
  buttons?: React.ReactNode[]
  title?: string
  content?: React.ReactNode
  children?: React.ReactElement<typeof AppModalContent>
  onClose?: never
}

interface ContentCustomProps
  extends React.ComponentPropsWithoutRef<typeof Stack> {
  content?: React.ReactNode
  buttons?: React.ReactNode[]
}

export const AppModalContent = ({ content, buttons }: ContentCustomProps) => {
  const filteredButtons = buttons
  return (
    <Stack w="100%" h="100%">
      <ScrollArea.Autosize
        mih={240}
        h={240}
        // type="always"
        scrollbars="y"
      >
        <Group w="100%" py={themeCfg?.default?.padding}>
          {content}
        </Group>
      </ScrollArea.Autosize>
      {/* {context} */}
      {buttons && (
        <Divider
          mt={0}
          mb={themeCfg?.default?.padding}
          orientation="horizontal"
        />
      )}
      {filteredButtons?.length > 0 && (
        <Group
          w="100%"
          h={50}
          justify={filteredButtons.length === 1 ? 'flex-end' : 'space-between'}
        >
          {filteredButtons?.map((button, index) => (
            <Group key={index}>{button}</Group>
          ))}
        </Group>
      )}
    </Stack>
  )
}

const AppModal = ({
  size = 'md',
  opened,
  close,
  buttons,
  title,
  content,
  children,
  ...otherProps
}: CustomProps) => {
  const modalSizeProps = () => {
    if (size === 'xl') return { w: 640, miw: 640 }
    return { w: 480, miw: 480 }
  }
  return (
    <Modal.Root
      {...otherProps}
      // scrollAreaComponent={ScrollArea.Autosize}
      opened={opened}
      centered
      onClose={close}
    >
      <Modal.Overlay blur={4} />
      <Modal.Content m={0} p={0} {...modalSizeProps()}>
        <Modal.Header bg="primary" py={0}>
          <Modal.Title c="white" fw="bold">
            <Group>{title}</Group>
          </Modal.Title>
          <Modal.CloseButton
            size="lg"
            variant="solid"
            bg="primary"
            pos="absolute"
            right={0}
            mr={themeCfg?.default?.padding}
            c="white"
          />
        </Modal.Header>
        <Modal.Body>
          {children ? children : content || null}
          {/* {!content && children && (
            <AppModalContent content={children} buttons={buttons} />
          )} */}
          {/* {!children && content && content} */}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}

export default AppModal
